import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import './index.css';
import img1 from '../../../src/images/left-white.svg'
import img2 from '../../../src/images/7-days-icon.svg'
import img3 from '../../../src/images/arr-down2.svg'
import img4 from '../../../src/images/Glucose-chart2.svg'
import img5 from '../../../src/images/Glucose-chart.svg'
import img8 from '../../../src/images/home2.svg';
import img9 from '../../../src/images/Icon (5).svg';
import img10 from '../../../src/images/notification.svg';
import img11 from '../../../src/images/Calendar3.svg';
import img12 from '../../../src/images/Icon (6).svg';

import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer,
    BarChart,
    Bar,
} from 'recharts';
import config from '../../config/config';



function GlucoseLevel() {
    const navigate = useNavigate();
    const location = useLocation();
    const { patientName, patientAge, patientCondition, patientId } = location.state || {};

    const [patients, setPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [weeklyStats, setWeeklyStats] = useState(null);
    const [dailyGlucoseData, setDailyGlucoseData] = useState([]);
    const [insulinVsGlucoseData, setInsulinVsGlucoseData] = useState([]);
    const [timeRange, setTimeRange] = useState(7);
    const [dateRange, setDateRange] = useState('');
    const [selectedRange, setSelectedRange] = useState(7); // Default range is 7 days
    const backendURL = `${config.backendServerHost}`;

// Place console.log statements to debug received state
console.log('Received data in GlucoseLevel:', {
    patientName,
    patientAge,
    patientCondition,
    patientId,
  });

useEffect(() => {
    fetch(`${backendURL}/patients/api/patients`)
        .then((res) => res.json())
        .then((data) => {
            setPatients(data); // Store all patients
            const foundPatient = data.find(patient => patient.name === patientName); // Find patient by name
            if (foundPatient) {
                setSelectedPatient(foundPatient); // Set the selected patient
            } else {
                console.error(`Patient with name "${patientName}" not found.`);
            }
        })
        .catch((error) => console.error('Error fetching patients:', error));
}, [backendURL, patientName]);

    useEffect(() => {
        if (selectedPatient) {
            // Calculate date range based on timeRange
            const today = new Date();
            const startDate = new Date(today);
            startDate.setDate(today.getDate() - timeRange + 1);

            const formattedStart = startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
            const formattedEnd = today.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
            setDateRange(`${formattedStart} - ${formattedEnd}`);

            fetch(`${backendURL}/patients/api/glucose-weekly-average/${selectedPatient.id}?range=${selectedRange}`)
                .then((res) => res.json())
                .then((data) => {
                    const chartData = (data?.last7DaysAverages || []).map((average, index) => ({
                        day: `Day ${index + 1}`,
                        glucose: parseFloat(average),
                    }));
                    setDailyGlucoseData(chartData);

                    fetch(`${backendURL}/patients/api/insulin-vs-glucose/${selectedPatient.id}?range=${selectedRange}`)
                        .then((res) => res.json())
                        .then((insulinData) => {
                            const combinedData = (insulinData || []).map((entry, index) => ({
                                ...entry,
                                glucose: chartData[index]?.glucose || entry.glucose,
                            }));
                            setInsulinVsGlucoseData(combinedData);
                        });
                });


             // Initialize state before fetching
            setWeeklyStats({ avgGlucose: "Loading...", timeInRange: "Loading...", readings: 7 });

            // Fetch time in range
           const fetchTimeInRange = fetch(`${backendURL}/patients/api/time-in-range/${selectedPatient.id}`)
                .then((res) => {
                    if (!res.ok) throw new Error("Failed to fetch time-in-range data");
                   return res.json();
                })
               .then((data) => data.timeInRange);

           // Fetch weekly glucose average
            const fetchWeeklyAverage = fetch(`${backendURL}/patients/api/glucose-weekly-average/${selectedPatient.id}?range=${selectedRange}`)
                .then((res) => {
                   if (!res.ok) throw new Error("Failed to fetch glucose weekly average data");
                   return res.json();
               })
               .then((data) => data.weeklyAverage);

           // Combine results from both API calls
           Promise.all([fetchTimeInRange, fetchWeeklyAverage])
              .then(([timeInRange, weeklyAverage]) => {
                   setWeeklyStats({
                        avgGlucose: weeklyAverage, // Value from glucose-weekly-average
                        timeInRange:timeInRange,  // Value from time-in-range
                       readings: 7               // Hardcoded for weekly stats
                   });
               })
               .catch((error) => {
                    console.error("Error fetching weekly stats:", error);
                   setWeeklyStats({ avgGlucose: "N/A", timeInRange: "N/A", readings: 7 });
               });
        }
    }, [selectedPatient]);

const WeeklyStats = ({ weeklyStats }) => (


                <div className='glucose_trend_cnt'>
                    <div className='average_glucose'>
                        <h3>{weeklyStats?.avgGlucose || 'N/A'}</h3>
                        <h4>mg/dL</h4>
                    </div>
                    <div className='average_glucose'>
                        <h3>{weeklyStats?.timeInRange || 'N/A'}</h3>
                        <h4 className='yellow-text'>70-180</h4>
                    </div>
                    <div className='average_glucose'>
                        <h3>{weeklyStats?.readings || 'N/A'}</h3>
                        <h4>Readings</h4>
                    </div>
            </div>
);

const DailyGlucoseGraph = ({ patientId }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!patientId) {
            setError('Patient ID is missing');
            setLoading(false);
            return;
        }

        setLoading(true);

        fetch(`${backendURL}/patients/api/glucose-weekly-average/${patientId}?range=${selectedRange}`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error("Failed to fetch glucose data");
                }
                return res.json();
            })
            .then((response) => {
                console.log('Response from glucose-weekly-average API:', response);

                if (!response.lastNDaysAverages || !Array.isArray(response.lastNDaysAverages)) {
                    throw new Error("Invalid data format: lastNDaysAverages is undefined or not an array");
                }

                const sortedData = response.lastNDaysAverages
                    .map(({ day, average }) => ({
                        day,
                        glucose: parseFloat(average),
                    }))
                    .sort((a, b) => new Date(a.day) - new Date(b.day));

                setData(sortedData);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Data Fetch Error:", err);
                setError(err.message);
                setLoading(false);
            });
    }, [patientId, selectedRange]);

    if (loading) return <div>Loading Daily Glucose Data...</div>;
    if (error) return <div>Error: {error}</div>;
    if (!data || data.length === 0) return <div>No glucose data available</div>;

    return (
        <div className="daily-glucose-graph">
            <h2>Daily Glucose Trends</h2>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="day" />
                    <YAxis domain={[0, 200]} />
                    <Tooltip />
                    <Line type="monotone" dataKey="glucose" stroke="#8884d8" />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};


const InsulinVsGlucoseGraph = ({ patientId }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!patientId) return;

        setLoading(true);
        fetch(`${backendURL}/patients/api/insulin-vs-glucose/${patientId}`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Failed to fetch Insulin vs Glucose data');
                }
                return res.json();
            })
            .then((response) => {
                setData(response);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, [patientId]);

    if (loading) return <div>Loading Insulin vs Glucose Data...</div>;
    if (error) return <div>Error: {error}</div>;
    if (!data || data.length === 0) return <div>No data available</div>;



    const handlePatientChange = (e) => {
        const patientId = e.target.value;
        const patient = patients.find((p) => p.id === patientId);
        setSelectedPatient(patient);
    };
    
    const handleTimeRangeChange = (e) => {
        setTimeRange(parseInt(e.target.value));
    };


    return (
        <div className="insulin-vs-glucose">
            <h2>Insulin vs Glucose Trends</h2>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="day" />
                    <YAxis
                        yAxisId="left"
                        label={{ value: 'Insulin (units)', angle: -90, position: 'insideLeft' }}
                        domain={[0, 70]}
                        tickFormatter={(value) => `${value}u`}
                    />
                    <YAxis
                        yAxisId="right"
                        orientation="right"
                        label={{ value: 'Glucose (mg/dL)', angle: -90, position: 'insideRight' }}
                        domain={[0, 180]}
                        tickFormatter={(value) => `${value} mg/dL`}
                    />
                    <Tooltip />
                    <Line
                        yAxisId="left"
                        type="monotone"
                        dataKey="insulin"
                        stroke="#82ca9d"
                        name="Daily Insulin Intake"
                        dot={{ r: 5 }}
                    />
                    <Line
                        yAxisId="right"
                        type="monotone"
                        dataKey="glucose"
                        stroke="#8884d8"
                        name="Daily Average Glucose"
                        dot={{ r: 5 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

    const handleRangeChange = (event) => {
        setSelectedRange(parseInt(event.target.value, 10));
    };

    const calculateDateRange = () => {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(endDate.getDate() - selectedRange);
        const options = { month: 'short', day: 'numeric' };

        return `${startDate.toLocaleDateString('en-US', options)} - ${endDate.toLocaleDateString('en-US', options)}`;
    };

    const navigateTo = (path, state = {}) => {
    navigate(path, { state });
    };
    
    return (
        <div className="glucose-main-cantainer">
            <div className='glucose_container'>
           <div className='glucose-navbar'>
                <div onClick={() => 
                    navigateTo('/patientinfo', {
                        state: { 
                            patientName, 
                            patientAge, 
                            patientCondition, 
                            patientId 
                        },
                    })
            }>
                <img src={img1} alt="Back to Patient Info" />
            </div>
            <div><h4>Glucose Trend</h4></div>
            <div></div>
        </div>
                <div className='days-button'><span><img src={img2} alt="" />
                </span>
                {/* Date Range */}
                <div className="header">
                    <select onChange={handleRangeChange} value={selectedRange}>
                       <option value={7}>7 Days</option>
                        <option value={14}>14 Days</option>
                        <option value={30}>30 Days</option>
                     </select>
                </div>
            </div>
            <div className='date-heading'><h5>{calculateDateRange()}</h5></div>

            {selectedPatient && weeklyStats && (
                <>
                    <WeeklyStats weeklyStats={weeklyStats} />
                    <DailyGlucoseGraph patientId={selectedPatient.id} />
                </>
            )}

            </div>

            <div className='glucose-wrapper'>
            {selectedPatient && weeklyStats && (
                <>
                    <InsulinVsGlucoseGraph patientId={selectedPatient.id} />
                </>
            )}


                <div className='key-insights-text'>
                    <h2>Key Insights & Recommendations</h2>
                    <div >
                        <h3>Nov 10 15:30</h3>
                        <h4>Range: 128 - 198 mg/dL</h4>
                    </div>
                    <div >
                        <h3>Nov 9 09:35</h3>
                        <h4>Range: 113 - 178 mg/dL</h4>
                    </div>
                    <div >
                        <h3>Nov 8 18:38</h3>
                        <h4>Range: 120 - 178 mg/dL</h4>
                    </div>
                    <div >
                        <h3>Nov 7 06:30</h3>
                        <h4>Bolus: Post-breakfast glucose spike</h4>
                    </div>
                    <div >
                        <h3>Nov 7 15:30</h3>
                        <h4>Bolus: Post-lunch glucose spike</h4>
                    </div>
                </div>
            </div>

        <div className="footer_container_wrapper">
                <div className="footer_container">
                    <div className="footer_icon" onClick={() => navigate('/dashboard-page')}>
                        <img src={img8} alt="Home Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/analysis')}>
                        <img src={img9} alt="Analytics Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/alerts')}>
                        <img src={img10} alt="Notification Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/appointments')}>
                        <img src={img11} alt="Calendar Icon" />
                    </div>
                    <div style={{ cursor: "pointer" }}>
                        <img src={img12} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GlucoseLevel;
